export const addNotification = (message, variant = 'success') => {
  const buildNotification = {
    message,
    options: {
      variant,
      autoHideDuration: 3000
    }
  };
  return enqueueSnackbar(buildNotification);
};
export const enqueueSnackbar = notification => {
  const key = notification.options && notification.options.key;

  return {
    type: 'NOTIFICATION/ENQUEUE_SNACKBAR',
    notification: {
      ...notification,
      key: key || new Date().getTime() + Math.random()
    }
  };
};

export const closeSnackbar = key => ({
  type: 'NOTIFICATION/CLOSE_SNACKBAR',
  dismissAll: !key, // dismiss all if no key has been defined
  key
});

export const removeSnackbar = key => ({
  type: 'NOTIFICATION/REMOVE_SNACKBAR',
  key
});
